import React from 'react';

//создаем контекст для прокидывания пропсов
export const AppContext = React.createContext(); 